<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Route Mapping</strong>
          </div>
          <b-row>
            
            <b-col md="4">
              <b-form-group>
                <b-row>
                  <b-col sm="3">
                    <label for="Hub"><b>Hub</b></label>&nbsp;<span style="color: red;">*</span>
                  </b-col>
                  <b-col sm="9">
                    <v-select v-model="selectedHub" :options="optionsHub" placeholder="-- Select Hub --" @input="updateSelect"></v-select>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          
            <b-col md="4">
              <b-button variant="primary" :pressed.sync="myToggle"
                @click="showVehiclelist()">Submit</b-button>
                <!-- this.showVehiclelist  getRoute-->
                <b-button type="submit" size="md" variant="danger" @click="clear()" style="margin-left: 10px"> clear</b-button>
            </b-col>
          </b-row>
          <!-- <b-card v-if="totalvehiclelist">
            <b>Available Vehicle :- </b> {{ available_list }}
          </b-card> -->
          <b-row>
            <b-col sm="12">
              <div v-for="(vehicle,index) in vehicleAcceptedLoads" :key="vehicle.vehicle_id">
                <b-card>
                 <b-row>
                  <b-col md="3"><b>Vehicle Number :- </b> {{ vehicle.vehicle_no }}</b-col>
                  <b-col md="3">
                    <b>Vehicle Capacity :- </b>
                    {{  vehicle.vehiclecapacity }}
                  </b-col>
                  
                  <b-col md="3">
                    <b> Occupied :- </b>
                    {{ vehicle.occupied.toFixed(2)}}
                  </b-col>
                  <b-col md="3">
                    <b> Space :- </b>
                    {{  vehicle.space}}
                  </b-col>
                </b-row>
               
                <br>
                <b-row>
                 
                  <b-col sm="12" class="text-right" v-if="vehicle.loads.length">
                    <!-- {{ vehicle.destination_sequence }} -->
                    <b-button variant="primary" @click="getMapData(vehicle,index)">Map{{ index+1 }}</b-button>
                  </b-col>
                  <!-- Total Dist Travelled -->
                 </b-row>
                 <hr>
                 <!-- <b-row>
                    <b-col sm="4">
                      <h6>City With Loads</h6>
                    </b-col>
                 </b-row> -->
                  <b-row>
                    <div v-for="(city,index) in vehicle.citycount">
                      
                        <button title="City With Load Count"   style="background-color: white !important; border: 1px solid #ccc;" class="btn btn-link" @click="getCityWiseMap(city)">
                              <span style="color:#1b8eb7"> {{index}} - {{ city.length }}</span>
                        </button>
                    </div>
                  </b-row>
                  <div class="table-responsive container p-3">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Load Id</th>
                          <th>Hub Pincode</th>
                          <th>Hub</th>
                          <!-- <th>Destination Pincode</th> -->
                          <th>Origin City</th>
                          <th>Origin State</th>
                          <th>Origin Pincode</th>
                          <th>Destination City</th>
                          <th>Destination State</th>
                          <th>Destination Pincode</th>
                          <!-- <th>Invoice Value</th> -->
                          <!-- <th>Is Franchise Order</th> -->
                          <th>Load Po Type</th>
                          <!-- <th>Shipping Company</th> -->
                          <!-- <th>No. of Boxes</th> -->
                          <!-- <th>Load Status</th> -->
                          <!-- <th>Original Dest City</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="load in vehicle.loads" :key="load.loadid">
                          <td>{{ load.loadid }}</td>
                          <td>{{load.hub_pincode}}</td>
                          <td>{{ load.currenthubid}}</td>
                          <!-- <td>{{ load.destinationpincode }}</td> -->
                          <td>{{load.origin_city}}</td>
                          <td>{{ load.origin_state}}</td>
                          <td>{{ load.sourcepincode }}</td>
                          <td>{{ load.dest_city }}</td>
                          <td>{{load.dest_state}}</td>
                          <td>{{ load.destinationpincode }}</td>
                          <!-- <td>{{ load.invoicevalue }}</td> -->
                          <!-- <td>{{load.isfranchiseorder}}</td> -->
                          <td>{{load.loadpotype}}</td>
                          <!-- <td>{{ load.shippingcompany}}</td> -->
                          <!-- <td>{{ load.noofboxes}}</td> -->
                          <!-- <td>{{ load.loadstatus}}</td> -->
                          <!-- <td>{{ load.original_destinationcity}}</td> -->
                          
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-card>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <!-- City Map -->

        <b-modal title="Map" @ok="showCityMap=false" v-model="showCityMap" hide-footer size="xl" @shown="initMapLoad">
          <b-row >
              <b-col md="12">
                <span class="green-dot"></span> <span class="dot">Start Point</span> &nbsp; <span class="yellow-dot"></span><span class="dot">Between Point</span> &nbsp; <span class="red-dot"></span><span class="dot">End Point</span>
              </b-col>
              <b-col md="12">
                <b-card class="mb-2">
                  <b-card-text>
                    <div id="map" style="height: 500px;"></div>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
         </b-modal>

         <!-- City Map -->

         <!-- Load Map -->

            <b-modal title="View Load Details" @ok="showloadtypedetails=false" v-model="showloadtypedetails" hide-footer size="xl" @shown=initMapLoadWise>
                    <div>
                      <b-row >
                          <b-col md="12">
                            <b-col md="12">
                              <span class="green-dot"></span> <span class="dot">First Point</span> &nbsp; <span class="yellow-dot"></span><span class="dot">Between Point</span> &nbsp; <span class="red-dot"></span><span class="dot">Last Point</span>
                            </b-col>
                            <b-card class="mb-2">
                              <b-card-text>
                                <div id="map" style="height: 500px;"></div>
                              </b-card-text>
                            </b-card>
                          </b-col>
                        
                      </b-row>  
                  <!-- <b-tabs content-class="mt-3" justified>
                    <b-tab title="City wise Load List" active>
                    
                      <b-table  show-empty responsive :items="loaditems" :fields="loadfields" :busy="loadisBusy">
                        <template #table-busy>
                          <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                        </template>
                       
                      </b-table>
                    </b-tab>
                    <b-tab title="Load Map" @click="initMapLoadWise">
                          
                        </b-tab>
                  </b-tabs> -->
                    </div>
            </b-modal>

        <!-- Load Map -->
          


            <!-- <b-row>
              <b-col>
                <b-modal title="Map" v-model="mapModel" size="xl" @ok="mapModel = false" hide-footer>
                <template slot="default" slot-scope="{ hide }">
                    <b-card>
                      <b-row>
                        <b-col sm="3"><b>Vehicle No. :- </b> {{ vehicle_no }}</b-col>
                        <b-col sm="3"><b> Capacity :- </b>{{ vehiclecapacity }}</b-col>
                        <b-col sm="3"><b> Occupied :- </b>{{  occupied}}</b-col>
                        <b-col sm="3"><b> Space :- </b>{{  space}}</b-col>
                      </b-row>
                     
                    </b-card>
                    <b-row class="mt-4">
                     
                      <b-col md="12" class="p-0">
                        <b-card>
                          <b-card-text>
                            <div style="overflow: scroll;" id="reloadMap" v-if="showMap">
                              <GmapMap :center="center" :zoom="7" map-type-id="terrain" style="width: 100%; height: 500px" @click="addmaploction($event,marker)">
                                      
                                        <DirectionsRenderer
                                          travelMode="DRIVING"
                                          :origin="startLocation"
                                          :destination="endLocation"
                                          :waypoints="waypnt"
                                          :optimizeWaypoints="true"/> 

                                          
                                
                                <gmap-info-window 
                                    @closeclick="window_open=false" 
                                    :opened="window_open" 
                                    :position="infowindow"
                                    :options="{
                                      pixelOffset: {
                                        width: 0,
                                        height: -35
                                      }
                                    }"
                                >
                                    {{formattedAddress}}
                                    <br><br>
                                    <div class="text-center p-2">
                                      <b-button variant="danger" size="sm" @click="deleteGroup(index)"> Remove </b-button>
                                    </div>
                                    
                                </gmap-info-window>
                                <gmap-info-window 
                                    @closeclick="addwindowclose" 
                                    :opened="addwindow_open" 
                                    :position="addinfowindow"
                                    :options="{
                                      pixelOffset: {
                                        width: 0,
                                        height: -30
                                      }
                                    }"
                                >
                                Are You Want To Add This Destination ( {{addformattedAddress}}) 
                              
                                <ejs-multiselect  placeholder="Select Pending Load" v-model="valueLoad" :dataSource='optionsLoad' :fields='fieldLoad'></ejs-multiselect>
                             
                                    <br><br>
                                    <div class="text-center p-2">
                                      <b-button variant="success" size="sm" @click="addmapinfo()" :disabled="valueLoad.length==0"> Add </b-button>
                                    </div>
                                    
                                </gmap-info-window> 
                               
                                
                              </GmapMap>
                            </div>
                            <div v-else>
                              <spinner v-if="spinnerFlag"></spinner>
                            </div>
                            <div class="text-center">
                              
                              <b-button squared variant="success" @click="generateRoute()"> Generate Route </b-button>
                            </div>
                          </b-card-text>
                        </b-card>
                      </b-col>
                    </b-row>
                  </template>
                  <template slot="modal-footer" slot-scope="{ cancel }">
                   
                    <b-button size="sm" variant="danger" @click="cancel()"> Cancel </b-button>
                    
                  </template>
                </b-modal>
              </b-col>
            </b-row> -->
      </b-col>
    </b-row> 
  </div>
</template>
<script>
  //  import DirectionsRenderer from "./DirectionsRenderer";
   import spinner from './Loader/spinner.vue';
  //  import customMarker from "./customMarker.vue";
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import Vue from "vue";
  export default {
    data() {
      return {
        vehicleAcceptedLoads: [],
        vehicleRejectedLoads: [],
        themObjForVehicle: [],
        KeyArr: {},
        fields: [{
            key: "loadid",
            label: "Load Id",
            sortable: true
          }, {
            key: "shipmentvolumetricweight",
            label: "Volumetric Weight",
            sortable: true
          }, {
            key: "hub_pincode",
            label: "Hub Pincode",
            sortable: true
          }, {
            key: "city",
            label: "Origin City",
            sortable: true
          }, {
            key: "sourcepincode",
            label: "Source Pincode",
            sortable: true,
          }, {
            key: "dest_city",
            label: "Destination City",
            sortable: true,
          }, {
            key: "destinationpincode",
            label: "Destination Pincode",
            sortable: true
          }, {
            key: "distance",
            label: "Distance",
            sortable: true,
          }, {
            key: "duration",
            label: "Duration",
            sortable: true,
          },
          // {duration}
        ],
//         city
// : 
// "PUNE"
// currenthubid
// : 
// 34
// dest_city
// : 
// "Pune Dhanori"
// dest_state
// : 
// "Maharashtra"
// destination_latlong
// : 
// {x: 18.6022018, y: 73.8425002}
// destinationpincode
// : 
// "411015"
// distanceunikey
// : 
// "410501411015"
// hub_pincode
// : 
// "410501"
// loadid
// : 
// "L27BW2324351294"
// loadpotype
// : 
// "b2f"
// origin_city
// : 
// "Pune"
// origin_state
// : 
// "MAHARASHTRA"
// parentawb
// : 
// "RB261234"
// shipmentvolumetricweight
// : 
// "4.66"
// shippincode
// : 
// "411015"
// sourcepincode
// : 
// "410501"
// unikeycd
// : 
// "410501411015_b2f"
// userid
// : 
// "2457"
        data1: [],
        rejectedtotalRows: 0,
        bordered: true,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'desc',
        filter: null,
        isBusy: false,
        mapModel: false,
        markers: [],
        center: {
          lat: 0,
          lng: 0
        },
        paths: [],
        polylineOptions: {
          strokeColor: '#86caf7', // Customize the polyline color
          strokeOpacity: 1.0,
          strokeWeight: 1,
        },
        available_vehiclelist: [],
        available_list: '',
        valueWH: [],
        optionsHub: [],
        HubData: [],
        valueVehicle: [],
        optionsVehicle: [],
        vehicleData:[],
        fieldVehicle: {
          text: 'name',
          value: 'id'
        },
        selectedHub: '',
        vehicleLoads:[],
        pendingLaods:[],
         infowindow: [],
        window_open: false,
        info_marker: null,
        formattedAddress :'',
        addinfowindow :[],
        addformattedAddress :'',
        addwindow_open: false,
        vehicle_Current_Index:null,
        selectvehicle : [],
        fieldLoad:{text: 'name',value: 'id'},
        valueLoad:[],
        optionsLoad:[],
        
        // optionvehicle :['MH56SH4389','LB67VU4793','RY47SV0306','SH27VI63271'],
        showSelectAll : true,
        vehicle_index:null,
        waypnt:[],
        startLocation: null,
        endLocation: null,
        loadWiseData:[],
        showDirection:false,
        vehicle_no:'',
        vehiclecapacity:null,
        space:'',
        occupied:null,
        showMap:true,
        spinnerFlag:false,
        // customSourceMarker: { lat: 40.748817, lng: -73.985428 }, // Custom source marker
        customSourceMarkerIcon: {
        url: 'https://cdn-icons-png.flaticon.com/128/9384/9384815.png', // Replace with your custom icon path
        scaledSize: new google.maps.Size(40, 80), // Adjust the size as needed
      },
      destinationPostalCode:null,
      showCityMap:false,
      waypoints : [],
      sourceLatLng : [],
      // waypoints : [{
      //   "lat": 19.113097,
      //   "lng":  72.854638
      //   },
      //   {
      //     "lat": 19.136087, 
      //   "lng":  72.851795
      //   },{ 
      //     "lat": 19.123680, 
      //     "lng": 72.846591
      //   }  ],
        Loadmap:null,
        directionsRenderers:null,
        showloadtypedetails:false,
        loaditems:[
          {'load_id':'INVCRBNR014','invoice_value':'116888.16', 'actual_weight':'673.75KG','volumetric_weight':'20'},
          {'load_id':'INVCRB2234','invoice_value':'555888.16', 'actual_weight':'453.75KG','volumetric_weight':'200'},
          {'load_id':'INVCRB9994','invoice_value':'116888.16', 'actual_weight':'673.75KG','volumetric_weight':'100'},
        ],
        loadfields :[
          
          {key:'load_id', label:'Load Id'},
          {key:'invoice_value', label:'Invoice Value'},
          {key:'actual_weight', label:'Actual Weight'},
          {key:'volumetric_weight', label:'Volumetric Weight'},
          {key:'action', label:'Action'},
        ],
        LoadmapWise:null,
        waypointsWise:[],
        directionsRenderer:null,
        // waypointsWise : [{
        // "lat": 19.113097,
        // "lng":  72.854638
        // },
        // {
        //   "lat": 19.136087, 
        // "lng":  72.851795
        // },{ 
        //   "lat": 19.123680, 
        //   "lng": 72.846591
        // }  ],

        cityWiseLatLng:[],
        sourceLatLngLoadWise:[]
      // markerNames: []
      };
    },
    components: {
    // DirectionsRenderer,
    spinner,
    // customMarker,
    },
    created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType = userInfo.user_type;
      // console.log("YYUUUU", this.userType);
      this.Usersysuser = userInfo.sysusermasterid;
      // console.log("Usersysuser", this.Usersysuser);
      this.user_id = userInfo.sysusermasterid;
      this.showWHlist();
      // this.getRoute();
    },
    methods: {
      getMapData(vehicle,index){
        // console.log('vehicle',vehicle,index)
        // let source =
        let waypoints = vehicle.destination_sequence;
        console.log("waypoints---------->",waypoints)
        // waypoints.map(item=>(console.log("item---------->",item)))
        // return false;
        this.waypoints=waypoints.map(item=>({
          "lat": parseFloat(item.latlong.x),
          "lng": parseFloat(item.latlong.y)
        }))
        console.log(`waypoints-----------------`,this.waypoints);
        // return false;
//          this.sourceLatLng = waypoints.map(item=>({
//           "lat": parseFloat(item.latlong.x),
//           "lng": parseFloat(item.latlong.y)
//         }));
//        console.log("this.sourceLatLng@@@@@@@@",this.sourceLatLng[0])
// // Insert the new element at the start of the array
//        this.waypoints.unshift(this.sourceLatLng[0]);

        console.log(")))))))))))))",this.waypoints);

        // console.log("this.waypoints",this.waypoints)
        this.showCityMap=true;

      },
       // Load Map Start
    //  initMapLoad() {
    //   this.Loadmap = new google.maps.Map(document.getElementById('map'), {
    //     center: { lat: 12.971598, lng: 77.594562 }, // Center the map at a default location
    //     zoom: 10,
    //   });

    // // Define directions service and renderer
    // const directionsService = new google.maps.DirectionsService();
    // this.directionsRenderers = new google.maps.DirectionsRenderer({ map: this.Loadmap });

    // // Create waypoints as LatLng objects
    // const waypointsLatLng = this.waypoints.map(waypoint => new google.maps.LatLng(waypoint.lat, waypoint.lng));
    // console.log("const waypointsLatLng@@@@@@",this.waypoints)
    // // Create request object for directions service
    // const request = {
    //   origin: waypointsLatLng[0],
    //   destination: waypointsLatLng[waypointsLatLng.length - 1],
    //   waypoints: this.waypoints.slice(1, -1).map(waypoint => ({ location: new google.maps.LatLng(waypoint.lat, waypoint.lng), stopover: true })),
    //   travelMode: google.maps.TravelMode.DRIVING,
    // };

    // // Request directions and render on the map
    // directionsService.route(request, (result, status) => {
    //   if (status === 'OK') {
    //     this.directionsRenderers.setDirections(result);
    //   } else {
    //     window.alert('Directions request failed due to ' + status);
    //   }
    // });

    // // Place markers at each waypoint
    // this.waypoints.forEach(waypoint => {
    //   new google.maps.Marker({
    //     position: { lat: waypoint.lat, lng: waypoint.lng },
    //     map: this.Loadmap, // Fix this line
    //     title: `(${waypoint.lat}, ${waypoint.lng})`,
    //   });
    // });
    //  },
    initMapLoad() {
        this.Loadmap = new google.maps.Map(document.getElementById('map'), {
          center: { lat: 12.971598, lng: 77.594562 },
          zoom: 10,
        });

        const directionsService = new google.maps.DirectionsService();
        this.directionsRenderers = new google.maps.DirectionsRenderer({ map: this.Loadmap });

        const waypointsLatLng = this.waypoints.map(waypoint => new google.maps.LatLng(waypoint.lat, waypoint.lng));

        const request = {
          origin: waypointsLatLng[0],
          destination: waypointsLatLng[waypointsLatLng.length - 1],
          waypoints: this.waypoints.slice(1, -1).map(waypoint => ({
            location: new google.maps.LatLng(waypoint.lat, waypoint.lng),
            stopover: true
          })),
          travelMode: google.maps.TravelMode.DRIVING,
        };
   console.log(`---------------------->`,request);
        directionsService.route(request, (result, status) => {
          if (status === 'OK') {
            this.directionsRenderers.setDirections(result);
          } else {
            window.alert('Directions request failed due to ' + status);
          }
        });

        // Place markers at each waypoint
        this.waypoints.forEach((waypoint, index) => {
          const marker = new google.maps.Marker({
            position: { lat: waypoint.lat, lng: waypoint.lng },
            map: this.Loadmap,
            title: `(${waypoint.lat}, ${waypoint.lng})`,
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              fillColor: index === 0 ? 'green' : (index === this.waypoints.length - 1 ? 'red' : 'yellow'),
              fillOpacity: 1,
              strokeColor: 'black',
              strokeWeight: 2,
              scale: 8 // Adjust the scale as needed
            }
          });
        });

  // waypoints.forEach((waypoint,index) => {
  //   const markerTitle = `Waypoint ${index + 1}: (${waypoint.lat}, ${waypoint.lng})`;
  //   new google.maps.Marker({
  //     position: { lat: waypoint.lat, lng: waypoint.lng },
  //     map: this.Loadmap,
  //     icon: http://maps.google.com/mapfiles/ms/icons/blue-dot.png, // Customize the marker icon
  //     // title: `(${waypoint.lat}, ${waypoint.lng})`,
  //     title:markerTitle,
  //   });
  // })
},

    // ...
// initMapLoad() {
//   this.Loadmap = new google.maps.Map(document.getElementById('map'), {
//     center: { lat: 12.971598, lng: 77.594562 }, // Center the map at a default location
//     zoom: 10,
//   });

//   // Define directions service and renderer
//   const directionsService = new google.maps.DirectionsService();
//   this.directionsRenderers = new google.maps.DirectionsRenderer({ map: this.Loadmap });

//   // Create waypoints as LatLng objects
//   const waypointsLatLng = this.waypoints.map(waypoint => new google.maps.LatLng(waypoint.lat, waypoint.lng));
//   console.log("const waypointsLatLng@@@@@@", this.waypoints)

//   // Split waypoints into chunks of 23 or fewer
//   const chunkSize = 23;
//   for (let i = 0; i < waypointsLatLng.length; i += chunkSize) {
//     const chunk = waypointsLatLng.slice(i, i + chunkSize);

//     // Create request object for directions service
//     const request = {
//       origin: i === 0 ? waypointsLatLng[0] : chunk[i - 1], // Use the last point of the previous chunk as the origin for subsequent chunks
//       destination: chunk[chunk.length - 1],
//       waypoints: chunk.slice(1, -1).map(waypoint => ({ location: waypoint, stopover: true })),
//       travelMode: google.maps.TravelMode.DRIVING,
//     };

//     // Request directions and render on the map
//     directionsService.route(request, (result, status) => {
//       if (status === 'OK') {
//         this.directionsRenderers.setDirections(result);
//       } else {
//         window.alert('Directions request failed due to ' + status);
//       }
//     });
//   }

//   // Place markers at each waypoint
//   this.waypoints.forEach(waypoint => {
//     new google.maps.Marker({
//       position: { lat: waypoint.lat, lng: waypoint.lng },
//       map: this.Loadmap, // Fix this line
//       title: `(${waypoint.lat}, ${waypoint.lng})`,
//     });
//   });
// },


// initMapLoad() {
//   this.Loadmap = new google.maps.Map(document.getElementById('map'), {
//     center: { lat: 12.971598, lng: 77.594562 },
//     zoom: 10,
//   });

//   const directionsService = new google.maps.DirectionsService();
//   this.directionsRenderers = new google.maps.DirectionsRenderer({ map: this.Loadmap });

//   const chunkSize = 23; // Maximum waypoints per request
//   const waypointGroups = this.chunkArray(this.waypoints, chunkSize);

//   for (let i = 0; i < waypointGroups.length; i++) {
//     const waypointsChunk = waypointGroups[i];

//     const waypointsLatLng = waypointsChunk.map(waypoint => new google.maps.LatLng(waypoint.lat, waypoint.lng));

//     const request = {
//       origin: waypointsLatLng[0],
//       destination: waypointsLatLng[waypointsLatLng.length - 1],
//       waypoints: waypointsChunk.slice(1, -1).map(waypoint => ({ location: new google.maps.LatLng(waypoint.lat, waypoint.lng), stopover: true })),
//       travelMode: google.maps.TravelMode.DRIVING,
//     };

//     directionsService.route(request, (result, status) => {
//       if (status === 'OK') {
//         this.drawRoute(result);
//       } else {
//         window.alert('Directions request failed due to ' + status);
//       }
//     });

//     // Place markers at each waypoint in the current chunk with a blue marker icon
//     this.addMarkers(waypointsChunk, 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png');
//   }
// },

// drawRoute(result) {
//   const directionsRenderer = new google.maps.DirectionsRenderer({
//     map: this.Loadmap,
//     directions: result,
//     suppressMarkers: true,
//     polylineOptions: {
//       strokeColor: 'blue',
//       strokeWeight: 4,
//     },
//   });
// },

// addMarkers(waypoints,iconUrl ) {
//   waypoints.forEach((waypoint,index) => {
//     const markerTitle = `Waypoint ${index + 1}: (${waypoint.lat}, ${waypoint.lng})`;
//     new google.maps.Marker({
//       position: { lat: waypoint.lat, lng: waypoint.lng },
//       map: this.Loadmap,
//       icon: http://maps.google.com/mapfiles/ms/icons/blue-dot.png, // Customize the marker icon
//       // title: `(${waypoint.lat}, ${waypoint.lng})`,
//       title:markerTitle,
//     });
//   });
// },

// chunkArray(array, size) {
//   const result = [];
//   for (let i = 0; i < array.length; i += size) {
//     result.push(array.slice(i, i + size));
//   }
//   return result;
// },


// ...

     // Load Map End
      getRoute() {
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        if(this.selectedHub!=''){
          let getHubName =this.selectedHub.label.split('-');
          let trimSpace=getHubName[1].trim();
          // console.log('etHubName===============>',getHubName[1].trim())
        const obj = {
          hubid:this.selectedHub.key,
          availablevehicles:this.available_vehiclelist,
          city:`${trimSpace}`
        };
        // return false;
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/finalSetRouteApi`, obj).then((result) => {
          document.getElementById("overlay").style.display = "none";
          console.log("result", result);
          if (result.body.returnmsg === "Successful") {
            // this.vehicleAcceptedLoads = result.body.vehicles;
            this.vehicleAcceptedLoads = result.body.returnvalue;
            // console.log('-this.vehicleAcceptedLoads ',this.vehicleAcceptedLoads );
            // this.pendingLaods=result.body.pendingloads;
            // let vehicleInfo=result.body.returnvalue.loads;
            // localStorage.setItem('vehicleInfo', JSON.stringify(vehicleInfo))
            // let pendingLoads=result.body.pendingloads;
            // localStorage.setItem('pendingLoads', JSON.stringify(pendingLoads))
            this.totalvehiclelist= this.vehicleAcceptedLoads.length;
            // this.showVehiclelist();
          } else {
            this.available_vehiclelist = [];
            this.pendingLaods = [];
            this.totalvehiclelist = 0;
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
        }else{
          this.$fire({
            text: "Please Select Hub",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlay").style.display = "none";
          return false;
        }
        
      },
      clear: function() {
        this.available_list='',
        this.totalvehiclelist = 0;
        this.selectedHub='';
        this.vehicleAcceptedLoads = [];
      },

      
     
      showWHlist: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var csvObj = {
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`
        };
        console.log("JJJJJ", csvObj);
        // return false;
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj).then(result => {
          if (result.body.returnmsg === 'Successful') {
            this.optionsHub = [];
            this.HubData = result.body.returnvalue;
            var data = [];
            this.HubData.forEach(function(srData) {
              data.push({
                key: srData.hubid,
                label: srData.hubid + " - " + srData.hubname
              });
            });
            this.optionsHub = data;
          } else {
            this.HubData = [];
          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
      },
      updateSelect(){
       this.vehicleAcceptedLoads=[];
        // this.showVehiclelist();
      },
      showVehiclelist: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        
        var csvObj = {
          hubid:`${this.selectedHub.key}`
          // warehouseid:'2001'
        }
        // return false;
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAvailableVehicleForWarehouseRoutePlanning`, csvObj).then(result => {
          if (result.body.returnmsg === 'Successful') {
            this.optionsVehicle = [];
            this.available_vehiclelist = result.body.returnvalue;
            var vehicleNos = "";
           
            for (let j = 0; j < this.available_vehiclelist.length; j++) {
              let vehicle = {
                name: this.available_vehiclelist[j].vehicle_id + " - " + this.available_vehiclelist[j].vehicle_no,
                id: this.available_vehiclelist[j].vehicle_id,
              }
              // console.log("hjjjjj",WH.name);
              this.optionsVehicle.push(vehicle);
              
              if (j > 0) {
                  vehicleNos += ",";
                }
                vehicleNos += this.available_vehiclelist[j].vehicle_no;
             // console.log("optionsWH",this.optionsWH);
            }
            
              this.available_list=vehicleNos;
              this.getRoute();
          } else {
            this.available_vehiclelist = [];
            this.available_list='';
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
      },
       
      // Load Map
      getCityWiseMap(data){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        document.getElementById("overlay").style.display = "block";
        // return false;
        let csvObj = {
          loads:data
        }
        // return false;
        console.log("csvObj@@@@@@",csvObj);
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getCityWiseMaps`, csvObj).then(result => {
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === 'Successful') {
           console.log("Esult@@@@@@@",result.body)
           this.cityWiseLatLng=result.body.returnvalue;
           this.showLoadModal(this.cityWiseLatLng);
          } else {
            this.cityWiseLatLng=[];
          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
      },
      showLoadModal(latLng){
        console.log("LatLNG",latLng);
        // this.showloadtypedetails=true
        // console.log("Data",data);
        let waypoints = latLng
        // console.log(waypoints);
        this.waypointsWise=waypoints.map(item=>({
          "lat": parseFloat(item.destination_latlong.x),
          "lng": parseFloat(item.destination_latlong.y)
        }))
          console.log("this.waypointsWise@@@@@2",this.waypointsWise);
         this.sourceLatLngLoadWise = waypoints.map(item=>({
          "lat": parseFloat(item.sourcelatlong.x),
          "lng": parseFloat(item.sourcelatlong.y)
        }));
       console.log("this.sourceLatLng@@@@@@@@",this.sourceLatLngLoadWise[0])
// Insert the new element at the start of the array
      //  this.waypointsWise.unshift(this.sourceLatLng[0]);

      //   console.log(")))))))))))))",this.waypointsWise);

        // console.log("this.waypoints",this.waypoints)
        // console.log("Data@@@@@@@@@@@22",data);
        this.showloadtypedetails=true;
          // console.log(data)
      },
      initMapLoadWise() {
        this.LoadmapWise = new google.maps.Map(document.getElementById('map'), {
          center: { lat: 12.971598, lng: 77.594562 },
          zoom: 10,
        });

        // Define directions service and renderer
        const directionsService = new google.maps.DirectionsService();
        this.directionsRenderers = new google.maps.DirectionsRenderer({ map: this.LoadmapWise });

        // Create waypoints as LatLng objects
        const waypointsLatLng = this.waypointsWise.map(waypoint => new google.maps.LatLng(waypoint.lat, waypoint.lng));

        // Create request object for directions service
        const request = {
          origin: waypointsLatLng[0],
          destination: waypointsLatLng[waypointsLatLng.length - 1],
          waypoints: this.waypointsWise.slice(1, -1).map(waypoint => ({ location: new google.maps.LatLng(waypoint.lat, waypoint.lng), stopover: true })),
          travelMode: google.maps.TravelMode.DRIVING,
        };

        // Request directions and render on the map
        directionsService.route(request, (result, status) => {
          if (status === 'OK') {
            this.directionsRenderers.setDirections(result);
          } else {
            window.alert('Directions request failed due to ' + status);
          }
        });

        // Place markers at each waypoint
        this.waypointsWise.forEach((waypoint, index) => {
          const marker = new google.maps.Marker({
            position: { lat: waypoint.lat, lng: waypoint.lng },
            map: this.LoadmapWise,
            title: `(${waypoint.lat}, ${waypoint.lng})`,
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              fillColor: index === 0 ? 'green' : (index === this.waypointsWise.length - 1 ? 'red' : 'yellow'),
              fillOpacity: 1,
              strokeColor: 'black',
              strokeWeight: 2,
              scale: 8, // Adjust the scale as needed
            },
          });

          // Add click event listener to the marker
         
        });
      },

    //   initMapLoadWise() {

    //   this.LoadmapWise = new google.maps.Map(document.getElementById('map'), {
    //     center: { lat: 12.971598, lng: 77.594562 }, // Center the map at a default location
    //     zoom: 10,
    //   });

    // // Define directions service and renderer
    //     const directionsService = new google.maps.DirectionsService();
    //     this.directionsRenderers = new google.maps.DirectionsRenderer({ map: this.LoadmapWise });

    //     // Create waypoints as LatLng objects
    //     const waypointsLatLng = this.waypointsWise.map(waypoint => new google.maps.LatLng(waypoint.lat, waypoint.lng));

    //     // Create request object for directions service
    //     const request = {
    //       origin: waypointsLatLng[0],
    //       destination: waypointsLatLng[waypointsLatLng.length - 1],
    //       waypoints: this.waypointsWise.slice(1, -1).map(waypoint => ({ location: new google.maps.LatLng(waypoint.lat, waypoint.lng), stopover: true })),
    //       travelMode: google.maps.TravelMode.DRIVING,
    //     };

    //     // Request directions and render on the map
    //     directionsService.route(request, (result, status) => {
    //       if (status === 'OK') {
    //         this.directionsRenderers.setDirections(result);
    //       } else {
    //         window.alert('Directions request failed due to ' + status);
    //       }
    //     });

    //     // Place markers at each waypoint
    //       this.waypointsWise.forEach(waypoint => {
    //         new google.maps.Marker({
    //           position: { lat: waypoint.lat, lng: waypoint.lng },
    //           map: this.LoadmapWise, // Fix this line
    //           title: `(${waypoint.lat}, ${waypoint.lng})`,
    //           icon: {
    //           path: google.maps.SymbolPath.CIRCLE,
    //           fillColor: index === 0 ? 'green' : (index === this.waypointsWise.length - 1 ? 'red' : 'yellow'),
    //           fillOpacity: 1,
    //           strokeColor: 'black',
    //           strokeWeight: 2,
    //           scale: 8 // Adjust the scale as needed
    //         }
    //         });
    //       });
    //   },
     
    },
    
  };
</script>
<style>
.custom-source-marker-container {
  position: absolute;
  z-index: 999; /* Adjust the z-index value to ensure it's above the DirectionsRenderer markers */
  top: 0; /* Adjust positioning as needed */
  left: 0; /* Adjust positioning as needed */
}
  .routetable th,
  td {
    text-align: center;
  }

  .route-border {
    border-bottom: 1px solid #c9bebe;
    margin: 30px 0px 20px 0px;
  }

  #overlay {
    position: fixed;
    /* Sit on top of the page content */
    /*display: none;*/
    /* Hidden by default */
    width: 100%;
    /* Full width (cover the whole page) */
    height: 100%;
    /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    /* Black background with opacity */
    z-index: 9999;
    /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer;
    /* Add a pointer on hover */
  }

  .loader {
    position: fixed;
    ;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 50px;
    height: 50px;
    left: 50%;
    top: 50%;
    -webkit-animation: spin 2s linear infinite;
    /* Safari */
    animation: spin 2s linear infinite;
  }

  .loading {
    position: relative;
    width: 50px;
    height: 50px;
    left: 50%;
    top: 56%;
  }
  .customMarker{
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: -1;
  }
  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  .dot{
    margin: 5px;
  }
  .red-dot {
  width: 20px;
  height: 20px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  border: 2px black solid;
}
.green-dot {
  width: 20px;
  height: 20px;
  background-color: green;
  border-radius: 50%;
  display: inline-block;
  border: 2px black solid;
}
.yellow-dot {
  width: 20px;
  height: 20px;
  background-color: yellow;
  border-radius: 50%;
  display: inline-block;
  border: 2px black solid;
}

</style>